// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"random-toll-free-link__wrapper3Om"};